import { useEffect, useState } from "react";
import { Building2, KeyRound } from "lucide-react";
import api, { apiError } from "@/lib/apiClient";

export function aiKeySource(business, info) {
  if (business.ai_model?.startsWith("gemini-")) {
    return aiKeySource({ ...business, ai_model: "", has_openai_key: business.has_gemini_key, openai_key_unavailable: business.gemini_key_unavailable }, info.gemini || {});
  }
  if (business.openai_key_unavailable || (info.configured && info.unavailable && !business.has_openai_key)) return { label: "Key perlu diisi ulang", id: "unavailable", color: "text-red-700 bg-red-500/10" };
  if (business.has_openai_key) return { label: "Milik Sendiri", id: "own", color: "text-emerald-700 bg-emerald-500/10" };
  if (info.configured) return { label: "Default Settings", id: "default", color: "text-purple-700 bg-purple-500/10" };
  return { label: info.environment_configured ? "Environment (.env)" : "Belum diatur", id: info.environment_configured ? "environment" : "missing", color: "text-amber-700 bg-amber-500/10" };
}

export default function AIKeySources({ businesses, role, onEditBusinessKey }) {
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const { data } = await api.get("/settings/default-openai-key");
        const gemini = businesses.some((business) => business.ai_model?.startsWith("gemini-")) ? (await api.get("/settings/default-gemini-key")).data : null;
        if (active) { setInfo({ ...data, gemini }); setError(""); }
      } catch (failure) { if (active) setError(apiError(failure)); }
    })();
    return () => { active = false; };
  }, [businesses]);
  const environmentCount = info ? businesses.filter((business) => aiKeySource(business, info).id === "environment").length : 0;
  return (
    <div className="bg-[#FFFFFF] border border-[#E2E8F0] rounded-2xl p-4 sm:p-6 space-y-3" data-testid="ai-key-source-card">
      <h3 className="font-heading font-bold flex items-center gap-2"><KeyRound size={18} className="text-purple-600" />Sumber Kunci AI per Bisnis</h3>
      {info && <p className="text-xs text-slate-600" data-testid="ai-key-environment-count">{environmentCount} bisnis memakai key environment bersama</p>}
      <p className="text-xs text-slate-600">Sesuai provider bisnis: key bisnis → key default Settings → OPENAI_API_KEY atau GEMINI_API_KEY dari environment.</p>
      {error && <p className="text-xs text-red-600" role="alert">{error}</p>}
      {!info && !error && <p className="text-xs text-slate-600">Memuat sumber key...</p>}
      {info && <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {businesses.map((business) => {
          const source = aiKeySource(business, info);
          const canEdit = role === "super_admin" && ["environment", "missing", "unavailable"].includes(source.id) && !!onEditBusinessKey;
          return <button type="button" key={business.id} disabled={!canEdit} onClick={() => onEditBusinessKey?.(business.id)} data-testid={`ai-key-source-${business.id}`} className="flex items-center justify-between gap-2 rounded-xl bg-[#F1F5F9] border border-[#E2E8F0] p-3 text-left disabled:cursor-default hover:enabled:border-purple-500">
            <span className="text-sm flex items-center gap-2 min-w-0"><Building2 size={15} className="shrink-0 text-slate-500" /><span className="truncate">{business.name}</span></span>
            <span data-testid={`ai-key-badge-${source.id}`} className={`text-[11px] rounded-md px-2 py-1 shrink-0 ${source.color}`}>{source.label}</span>
          </button>;
        })}
        {!businesses.length && <p className="text-xs text-slate-600">Belum ada bisnis.</p>}
      </div>}
    </div>
  );
}
